import gql from "graphql-tag";

export default gql`
	query getTrialQuery($trialId: String!) {
		getTrialById(trialId: $trialId) {
			id
		}
	}
`;

export const readTrial = ({ data }) => data && data.getTrialById;
